import { Injectable, AfterViewInit } from '@angular/core';
import { L10n } from '@syncfusion/ej2-base';
import { StorageManagerService } from './storage-manager.service';

@Injectable()
export class GridPreferencesService implements AfterViewInit {
  filterSettings = {};

  constructor(private storageManagerService: StorageManagerService) { }

  ngAfterViewInit() {
    this.loadLocalizationSettings();
  }

  loadLocalizationSettings() {
    const isBncc = document.getElementById('bnccEstablishmentEditAlert');
    if (isBncc) {
      L10n.load({
        'en-US': {
          grid: {
            CancelButton: 'Cancel',
            OKButton: 'OK'
          }
        }
      });
    } else {
      L10n.load({
        'en-US': {
          grid: {
            CancelButton: 'Cancel',
            OKButton: 'Apply',
          }
        }
      });
    }
  }

  onGridPreferencesSave(pageName, gridId, gridReference, event?) {
    if (!event || !event.requestType) {
      return;
    }

    const requestType = String(event.requestType).toLowerCase();
    if (requestType === 'filtering' || requestType === 'clearfiltering' || requestType === 'refresh' || requestType === 'searching') {
      return;
    }

    const userguid = this.storageManagerService.read('userData').userguid;
    let colsObject = [];

    gridReference.columns.map(column => {
      if (column.headerText) {
        colsObject.push({ headerText: column.headerText });
      }
      return column;
    });

    // Strip filter state from persist data so stale filters are never saved to localStorage.
    // Previously this was done via clearFiltering()/restore dance, but that fired a spurious
    // dataStateChange which triggered unwanted server-side reloads on every paging action.
    let persistDataObj: any = {};
    try {
      persistDataObj = JSON.parse(gridReference.getPersistData());
    } catch (_) {}
    if (persistDataObj.filterSettings) {
      persistDataObj.filterSettings = { columns: [] };
    }
    // Strip selection state so previously selected rows are never restored across page loads.
    delete persistDataObj.selectedRowIndex;
    delete persistDataObj.selectionModule;

    let gridPrefenceSettings: any = localStorage.getItem('gridPrefenceSettings' + userguid);
    gridPrefenceSettings = gridPrefenceSettings ? JSON.parse(gridPrefenceSettings) : {};
    gridPrefenceSettings[pageName] = gridPrefenceSettings[pageName] ?? {};
    gridPrefenceSettings[pageName][gridId] = { settings: JSON.stringify(persistDataObj), columns: colsObject };

    localStorage.setItem('gridPrefenceSettings' + userguid, JSON.stringify(gridPrefenceSettings));
  }

  onGridPreferencesRestore(pageName, gridId, gridReference) {
    const userguid = this.storageManagerService.read('userData').userguid;
    let gridPrefenceSettings: any = localStorage.getItem('gridPrefenceSettings' + userguid);
    if (gridPrefenceSettings) {
      gridPrefenceSettings = JSON.parse(gridPrefenceSettings);

      if (gridPrefenceSettings[pageName] && gridPrefenceSettings[pageName][gridId]) {
        this.restoreHandler(pageName, gridId, gridReference, gridPrefenceSettings[pageName][gridId].settings);
      }
    }
  }

  checkboxClick(grid_ref, disabledColumns) {
    setTimeout(function (e) {
      const dialogContents = document.getElementsByClassName('e-dlg-content')[0];
      let sortedUL = dialogContents.querySelectorAll('ul')[0];

      grid_ref.columnModel.forEach((column, index) => {
        if (disabledColumns) {
          let disabledColumn = disabledColumns.find(x => x === column.headerText);
          if (disabledColumn) {
            this.addElement(sortedUL, disabledColumn, index);
          }
        }
      });
    }.bind(this));
  }

  addElement(parentElement, textContent, position) {
    let li = document.createElement("li");
    let div = document.createElement("div");
    div.setAttribute("class", "e-ccheck");
    let wrapperDiv = document.createElement("div");
    wrapperDiv.setAttribute("class", "e-checkbox-wrapper e-css e-checkbox-disabled");
    let box = document.createElement("span");
    box.setAttribute("class", "e-icons e-check custom-checkbox-chooser");
    let span = document.createElement("span");
    span.setAttribute("class", "e-label");
    span.appendChild(document.createTextNode(textContent));
    wrapperDiv.appendChild(box);
    wrapperDiv.appendChild(span);
    div.appendChild(wrapperDiv);
    li.appendChild(div);
    li.setAttribute("class", "e-cclist e-cc");
    parentElement.insertBefore(li, parentElement.childNodes[position]);
  }

  restoreHandler(pageName, gridId, grid, settings) {
    let savedProperties = JSON.parse(settings);
    delete savedProperties.selectedRowIndex;
    delete savedProperties.selectionModule;
    let gridColumnsState = Object.assign([], grid.getColumns());

    // Remove saved columns that no longer exist in the current grid definition
    savedProperties.columns = savedProperties.columns.filter((col: any) =>
      gridColumnsState.some((current: any) => current.field === col.field)
    );

    // Add new columns (exist in current grid but not in saved state) with defaults
    gridColumnsState.forEach((current: any) => {
      if (current.field && !savedProperties.columns.some((col: any) => col.field === current.field)) {
        savedProperties.columns.push({
          field: current.field,
          visible: true,
          width: current.width
        });
      }
    });

    savedProperties.columns.forEach(function (col: any) {
      const currentCol = gridColumnsState.find(function (colColumnsState: any) { return colColumnsState.field === col.field; });
      if (currentCol) {
        col.headerText = currentCol['headerText'];
        col.template = currentCol['template'];
        col.headerTemplate = currentCol['headerTemplate'];
        // Keep column chooser visibility in sync with current grid definitions.
        col.showInColumnChooser = currentCol['showInColumnChooser'] !== false;
      }

    });
    if (this.filterSettings[pageName] && this.filterSettings[pageName][gridId]) {
      grid.filterSettings.columns = this.filterSettings[pageName][gridId];
    }

    grid.setProperties(savedProperties);
  }
}
